export const sessionStorageKeys = {
  purchaseTrackingId: 'purchaseTrackingId',
  utmTags: 'utmTags',
  channelName: 'fairlo.analytics.channelName',
  staleChunkReloaded: 'fairlo.staleChunkReloaded',
  DEVTOOLS_DISABLED_FOR_SESSION: 'fairlo.devtools.disabledForSession',
  DEVTOOLS_ANALYTICS_LOGGING_ENABLED: 'fairlo.devtools.analyticsLoggingEnabled',
  DEVTOOLS_FI_SIGNICAT_SANDBOX: 'fairlo.devtools.fiSignicatSandbox',
  DEVTOOLS_MSW_ENABLED: 'fairlo.devtools.mswEnabled',
  DEVTOOLS_FEATURE_FLAG_OVERRIDES: 'fairlo.devtools.featureFlagOverrides',
  DEVTOOLS_UK_APPLICATION_SOURCE: 'fairlo.devtools.ukApplicationSource',
  lastSeenNumber: 'fairlo.lastSeenNumber',
} as const;
